var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-upload",
        {
          attrs: {
            accept: _vm.accept,
            multiple: _vm.limit > 1,
            "file-list": _vm.fileList,
            "before-upload": _vm.beforeFileUpload,
            customRequest: _vm.handleFileUpload,
            disabled: _vm.disabled || _vm.fileList.length >= _vm.limit,
            showUploadList: false
          }
        },
        [
          _c(
            "a-button",
            { staticClass: "spaceLeft", staticStyle: { color: "#1990ff" } },
            [
              _c(
                "svg",
                {
                  staticClass: "icon img-icon",
                  attrs: { "aria-hidden": "true" }
                },
                [
                  _c("use", {
                    attrs: { "xlink:href": "#gold-icon-shangchuan" }
                  })
                ]
              ),
              _vm._v("上传文件\n      ")
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.tableData.length > 0
        ? _c(
            "div",
            { staticClass: "table-common common tableData" },
            [
              _c("a-table", {
                attrs: {
                  scroll: { x: "100%", y: "170px" },
                  loading: _vm.tableLoading,
                  size: "middle",
                  "row-key": function(record, index) {
                    return record.id + "_" + index
                  },
                  columns: _vm.columns,
                  "data-source": _vm.tableData,
                  pagination: false,
                  bordered: "",
                  locale: { emptyText: "暂无数据" }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "createTime",
                      fn: function(text) {
                        return [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm._f("dateFormat")(
                                  text,
                                  "YYYY-mm-dd HH:MM:SS"
                                )
                              ) +
                              "\n        "
                          )
                        ]
                      }
                    },
                    {
                      key: "status",
                      fn: function(text, record) {
                        return [
                          record.status === "done"
                            ? _c("img", {
                                attrs: {
                                  width: "18",
                                  height: "18",
                                  src: require("../../../assets/images/icon-img/file_done.png")
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          record.status === "uploading"
                            ? _c("img", {
                                attrs: {
                                  width: "18",
                                  height: "18",
                                  src: require("../../../assets/images/icon-img/file_done.png")
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          record.status === "wait" || record.status === ""
                            ? _c("img", {
                                attrs: {
                                  width: "18",
                                  height: "18",
                                  src: require("../../../assets/images/icon-img/file_done.png")
                                }
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.getStatusRecod(record)) +
                              "\n        "
                          )
                        ]
                      }
                    },
                    {
                      key: "oper",
                      fn: function(text, record, index) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "text-color-red pointer",
                              on: {
                                click: function($event) {
                                  return _vm.delFun(record, index)
                                }
                              }
                            },
                            [_vm._v("删除")]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1450561410
                )
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e7fe3ab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e7fe3ab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/qxkl-file-upload/index.vue
// module id = Rr6G
// module chunks = 1